<script>

    import Image from "./Image.svelte";
    import {optionsStore} from "../core/app-store.js";
    import {createEventDispatcher} from "svelte";
    import {eventBus} from "../core/event-bus-store.js";
    const dispatch = createEventDispatcher();

    export let record;
    export let publishConfig;
    export let tenantKey;
    export let cardHeight;

    const toggleDetailsScreen = (record) => {
        dispatch('toggleDetailsScreen', record);
    }

    const removeFromCartHandler = (record) => {
        if (record?.prices?.length > 1 || record?.mods?.length > 1) {
            eventBus.set([{event: 'openEditDetailsHalfScreen', payload: {record, mode: 'removeItems'}}]);
        }
        else {
            dispatch('removeFromCart', record);
        }
    }

    const addToCartHandler = (record) => {

        if (record?.prices?.length > 1 || record?.mods?.length > 1) {
            eventBus.set([{event: 'openEditDetailsHalfScreen', payload: {record, mode: 'addItems'}}]);
        }
        else {
            dispatch('addToCart', record);
        }
    }

</script>
<style>

    .card {
        flex: 1 1 45%;
        min-height: 190px;
        overflow: hidden;
    }
    .card--double {
        flex: 1 1 100%;
    }
    .card .record-title {
        font-size: var(--fs-110);
        font-weight: 400;
        padding-bottom: .25rem;
        padding-top: 0.1rem;
        letter-spacing: .25px;
        word-break: break-word;
    }
    .card .media-block {
        position: relative;
    }
    .card .media-block .labels .label--red {
        position: absolute;
        top: 0;
        left: 0;
        padding: 0.35rem 0.5rem;
        font-weight: 400;
        font-size: .9rem;
        display: flex;
        align-items: center;
        background: var(--success-bg-color);
        color: var(--header-background);
        border-bottom-right-radius: 0.75rem;
        border-top-left-radius: 0.75rem;
        overflow: hidden;
    }
    .card .media-block .order-buttons {
        position: absolute;
        bottom: 0;
        right: 0;
    }
    .card .prices-block {
        padding-top: 0.35rem;
        letter-spacing: 0.5px;
        gap: .5rem;
    }
    .card .prices-block .price {
        font-size: var(--fs-130);
        font-weight: 600;
    }
    .card .prices-block .price--old {
        font-size: var(--fs-100);
        opacity: .8;
        text-decoration: line-through;
    }
    .card .prices-block .separator,
    .card .prices-block .weight {
        font-size: var(--fs-100);
        font-weight: 500;
        color: var(--secondary-font-color);
    }

    .card.card--promo .found_description {
        color: var(--promo-card-text-color, white);
        flex-basis: 100%;
    }

    @media (max-width: 767px) {
        .card.card--promo {
            flex-basis: 100%;
            display: flex;
            flex-wrap: wrap;
            background: var(--promo-card-bg-color, indianred);
            gap: 1rem;
            padding: 16px;
            margin: 0 -20px;
        }
        .card.card--promo ~ .card--promo{
            margin-top: calc(-1rem - 1px);
        }
        .card.card--promo .media-block {
            flex: 1;
            height: fit-content;
        }
        .card.card--promo .card-info-block {
            flex: 1;
            justify-content: center;
            align-items: center;
            text-align: center;
            display: flex;
            flex-direction: column-reverse;
        }
        .card.card--promo .card-info-block .record-title {
            font-size: 1.5rem !important;
            font-weight: 500 !important;
            line-height: 1.2;
            color: var(--promo-card-text-color, white);
        }
        .card.card--promo .card-info-block .price {
            color: var(--promo-card-text-color, white);
            font-size: 1rem;
        }
        .card.card--promo .card-info-block .from {
            color: var(--promo-card-text-color, white);
        }
        .card.card--promo .card-info-block .weight {
            color: var(--promo-card-text-color, white);
            font-size: 1rem;
        }
        .card.card--promo .card-info-block .favorite {
            color: var(--promo-card-text-color, white);
        }
    }

    @media (min-width: 768px) {
        .card {
            flex: 1 1 30%;
        }
        .card .record-title {
            font-size: var(--fs-100);
        }
        .card--promo {
            background: var(--promo-card-bg-color, indianred);
            gap: 1rem;
            padding: 3px 3px 0 3px;
            margin: -3px -3px 3px -3px;
            border-radius: 1rem;
        }
        .card.card--promo .card-info-block {
            padding: 0 0.5rem 0.5rem 0.5rem;
        }
        .card.card--promo .card-info-block .record-title {
            color: var(--promo-card-text-color, white);
        }
        .card.card--promo .card-info-block .price {
            color: var(--promo-card-text-color, white);
        }
        .card.card--promo .card-info-block .weight {
            color: var(--promo-card-text-color, white);
        }
        .card.card--promo .card-info-block .favorite {
            color: var(--promo-card-text-color, white);
        }
        .card.card--promo .found_description {
            color: var(--promo-card-text-color, white);
            flex-basis: 100%;
            padding: 0 .5rem .5rem .5rem;
        }
    }
</style>

<div class="card user-select-none pointer {record.recordType === 'double-card' ? 'card--double' : ''} {record.promoted?.enabled === true ? 'card--promo' : ''}" on:click={() => toggleDetailsScreen(record)}>

    <div class="media-block">
        {#if (record?.media?.length > 0)}
            <Image src={record?.media[0]?.name}
                   tenantKey={record?.media[0]?.ref || tenantKey}
                   hasVideo={ (record.media || []).find(x => x.type === 'video') !== undefined }
                   animation="{ record.promoted?.enabled === true ? 'scale' : 'none' }"
                   imgHeight="{cardHeight}"
                   alt={record?.name || ''}>
            </Image>
        {:else }
            <Image imgHeight="{cardHeight}"
                   alt={record?.name || ''}>
            </Image>
        {/if}

        {#if (record.label !== null && record.label !== undefined)}
            <div class="labels">
                <div class="label--red">{ record.label }</div>
            </div>
        {/if}

        {#if (publishConfig.disableCart !== true)}
        <div class="order-buttons">
            {#if ( (record?._orderedItems || 0) > 0)}
                <button class="add-button pointer" on:click|stopPropagation={removeFromCartHandler(record)}>-</button>
                <span>{record?._orderedItems}</span>
            {/if}
            <button class="add-button pointer" on:click|stopPropagation={addToCartHandler(record)}>+</button>
        </div>
        {/if}
    </div>

    <div class="card-info-block">

        {#if (record.prices && record.prices.length > 0)}
            <div class="prices-block flex-between">
                <div>

                    {#if (record.prices[0].oldPrice !== null && record.prices[0].oldPrice !== undefined)}
                        <span class="price price--old">
                            { record.prices[0].oldPrice }
                        </span>
                    {/if}

                    {#if (record.prices[0].price !== null && record.prices[0].price !== undefined)}
                        {#if (record.prices?.length > 1 || record.mods?.length > 0)}
                            <span class="from">от </span>
                        {/if}
                        <span class="price">
                            {record.prices[0].price} {publishConfig?.currency ? publishConfig.currency : ''}
                        </span>
                    {/if}
                    {#if (record.prices[0].weight)}
                        <span class="separator">/</span>&nbsp;<span class="weight">{record.prices[0].weight}</span>
                    {/if}
                </div>
                <div>
                    {#if record.isFavorite}
                        <span class="favorite">
                            <svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Heart"><path d="M7 3C4.239 3 2 5.216 2 7.95c0 2.207.875 7.445 9.488 12.74a.985.985 0 0 0 1.024 0C21.125 15.395 22 10.157 22 7.95 22 5.216 19.761 3 17 3s-5 3-5 3-2.239-3-5-3z"/></svg>
                        </span>
                    {/if}
                </div>
            </div>
        {/if}

        {#if ($optionsStore.showMealTitleAtFrontPage)}
            <div class="record-title">
                {record.name || ''}
            </div>

            {#if (record._found_desc && !record.promoted?.enabled)}
            <div class="found_description fs-90 lh-110">
                {@html record._found_desc }
            </div>
            {/if}
        {/if}
    </div>

    {#if (record._found_desc && record.promoted?.enabled === true)}
        <div class="found_description fs-90 lh-110 flex-fill">
            {@html record._found_desc }
        </div>
    {/if}

</div>
